import * as pdfjsLib from 'pdfjs-dist';
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.min.mjs?url';

// Set up PDF.js worker - use the bundled worker from node_modules
pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

/**
 * Extract a specific page from a PDF and convert it to a base64 image data URL
 * @param pdfUrl - Public URL to the PDF file
 * @param pageNumber - Page number to extract (1-indexed)
 * @returns Base64 data URL (e.g., "data:image/png;base64,...")
 */
export async function extractPdfPageAsImage(pdfUrl: string, pageNumber: number): Promise<string> {
  try {
    console.log(`📄 Loading PDF from: ${pdfUrl}`);
    console.log(`📍 Extracting page ${pageNumber}`);

    // Load the PDF document
    const loadingTask = pdfjsLib.getDocument(pdfUrl);
    const pdf = await loadingTask.promise;

    console.log(`✅ PDF loaded, total pages: ${pdf.numPages}`);

    if (pageNumber > pdf.numPages) {
      throw new Error(`Page ${pageNumber} does not exist (PDF has ${pdf.numPages} pages)`);
    }

    // Get the specific page
    const page = await pdf.getPage(pageNumber);

    // Set up canvas with high resolution
    const scale = 2.0; // Higher scale = better quality
    const viewport = page.getViewport({ scale });

    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');

    if (!context) {
      throw new Error('Failed to get canvas 2D context');
    }

    canvas.width = viewport.width;
    canvas.height = viewport.height;

    // Render the page to canvas
    const renderContext = {
      canvasContext: context,
      viewport: viewport,
    };

    await page.render(renderContext as any).promise;

    console.log(`✅ Page rendered to canvas (${canvas.width}x${canvas.height})`);

    // Convert canvas to base64 data URL
    const dataUrl = canvas.toDataURL('image/png');

    console.log(`✅ Converted to base64 data URL (${(dataUrl.length / 1024).toFixed(2)} KB)`);

    return dataUrl;
  } catch (error) {
    console.error('❌ Failed to extract PDF page as image:', error);
    throw error;
  }
}
